module.exports = __webpack_public_path__ + "static/img/banner.b4841c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/longda/banner.png
// module id = /kVy
// module chunks = 32